import { render, staticRenderFns } from "./AssignTrainerToContentDropdown.vue?vue&type=template&id=084b1f83&scoped=true"
import script from "./AssignTrainerToContentDropdown.vue?vue&type=script&lang=js"
export * from "./AssignTrainerToContentDropdown.vue?vue&type=script&lang=js"
import style0 from "./AssignTrainerToContentDropdown.vue?vue&type=style&index=0&id=084b1f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b1f83",
  null
  
)

export default component.exports